import React from 'react';
import { ShimmerCircularImage, ShimmerTitle } from "react-shimmer-effects";

const CommentListLoader = () => {
  
  return (
    <>
      {
        Array.from({ length: 8 }).map((_, index) => {
          return (
            <div className={`mx-n-15 pd-x-15 d-flex align-items-center ${index === 0 ? 'pd-b-15' : 'pd-y-15 border-top border-gray-700'}`}>
              <div className="d-flex w-100">
                <ShimmerCircularImage size={30} className="mg-b-0" />
                <div className="w-100 mg-l-10 mg-t-8">
                  <div className='d-flex align-items-center justify-content-between w-100 mg-b-10'>
                    <div style={{ width: '120px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
                    <div style={{ width: '50px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
                  </div>
                  <ShimmerTitle line={2} gap={0} variant="primary" className="mg-b-0 d-block" />
                </div>
              </div>
              
                
                {/* <ShimmerCircularImage size={20} className="mg-b-0" /> */}
            </div>
          )
        })
      }
    </>
  );
};

export default CommentListLoader;
